import React from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import UserChangePasswordForm from "./userComponents/UserChangePasswordForm";

import {
  useDetailUserQuery,
  useEditDetailPasswordMutation,
} from "store/services/userApi";

const UserChangePasswordScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  // RTK Query
  const {
    data: userDetail,
    isLoading: loadingUserDetail,
    error,
  } = useDetailUserQuery(id);

  const [updatePassword, { isLoading: updatingUserPassword }] =
    useEditDetailPasswordMutation();

  const breadcrumbs = [
    { title: "Users", path: "/app/crm/user/list" },
    {
      title: userDetail ? userDetail?.name : "User Detail",
      path: `/app/crm/user/${id}/detail`,
    },
    { title: "Change Password" },
  ];

  // methods
  const handleUpdateUserPassword = async (data) => {
    try {
      await updatePassword({
        id: userDetail?._id,
        password: data?.password,
      }).unwrap();
      toast.success("User's password successfully updated!");
      navigate(breadcrumbs[1]?.path);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update password!");
    }
  };

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={updatingUserPassword || loadingUserDetail}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <UserChangePasswordForm
          isBusy={updatingUserPassword || loadingUserDetail}
          onSubmit={handleUpdateUserPassword}
          onCancel={() => navigate(breadcrumbs[1]?.path)}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default UserChangePasswordScreen;
